import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
  Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const login = r => require.ensure([], () => r(require('@/page/login1')), 'login');
const manage = r => require.ensure([], () => r(require('@/page/manage2')), 'manage');
const shopList = r => require.ensure([], () => r(require('@/page/shopList')), 'shopList');
const TeacherList = r => require.ensure([], () => r(require('@/page/TeacherList')), 'TeacherList');
const HireList = r => require.ensure([], () => r(require('@/page/HireList')), 'HireList');
const ResumeList = r => require.ensure([], () => r(require('@/page/ResumeList')), 'ResumeList');
const TeaWorkPublishList = r => require.ensure([], () => r(require('@/page/TeaWorkPublishList')), 'TeaWorkPublishList');
const DancevarietyList = r => require.ensure([], () => r(require('@/page/DancevarietyList')), 'DancevarietyList');
const PositionList = r => require.ensure([], () => r(require('@/page/PositionList')), 'PositionList');

const WinningList = r => require.ensure([], () => r(require('@/page/WinningList')), 'WinningList');



const routes = [
  // {
  //   path: "/",
  //   component: HelloWorld,
  //   name: "HelloWorld",
  // },
  {
    path: "/",
    component: login,
    name: "login",
  },
  {
    path: '/manage',
    name: '/manage',
    component: manage,
    children: [{
      path: '',
      name: '',
      meta: [],
    },
     
    {
      path: '/shopList',
      name:'shopList',
      component: shopList,
      meta: {
        breadcrumb:['商户列表'],
        defaultActive:'1'
      }
    }, {
      path: '/TeacherList',
      name:'TeacherList',
      component: TeacherList,
      meta: {
        breadcrumb:['老师列表'],
        defaultActive:'2'
      }
    },{
      path: '/HireList',
      name:'HireList',
      component: HireList,
      meta: {
        breadcrumb:['招聘审核列表'],
        defaultActive:'3'
      }
    },
    
    {
      path: '/ResumeList',
      name:'ResumeList',
      component: ResumeList,
      meta: {
        breadcrumb:['简历审核列表'],
        defaultActive:'4'
      }
    },

    
    {
      path: '/TeaWorkPublishList',
      name:'TeaWorkPublishList',
      component: TeaWorkPublishList,
      meta: {
        breadcrumb:['工作审核列表'],
        defaultActive:'5'
      }
    },
    {
      path: '/DancevarietyList',
      name:'DancevarietyList',
      component: DancevarietyList,
      meta: {
        breadcrumb:['舞种配置'],
        defaultActive:'6-1'
      }
    }   ,
    {
      path: '/PositionList',
      name:'PositionList',
      component: PositionList,
      meta: {
        breadcrumb:['舞种配置'],
        defaultActive:'6-2'
      }
    },
    {
      path: '/WinningList',
      name:'WinningList',
      component: WinningList,
      meta: {
        breadcrumb:['荣誉认证'],
        defaultActive:'6-3'
      }
    },
    
    
    
  ]}
]

export default new Router({
  routes,
  // strict: process.env.NODE_ENV !== 'production',
})



// WEBPACK FOOTER //
// ./src/router/index.js